import SharePop from "./share-popup";


export default SharePop;